import React, { PureComponent } from 'react';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import SmartCard from '../../../shared/components/SmartCard';
import validate from './Validate';
import GraphQL from '../../../GraphQL';
import renderField from '../../../shared/components/form/RenderField';
import renderSelectField from '../../../shared/components/form/Select';
import { schoolGradeListByFilter } from '../../../shared/queries/SchoolGrade';
import { educationStageListByFilterQuery } from '../../../shared/queries/EducationStage';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

class SchoolGradeForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    backHandler: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    dto: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      active: PropTypes.bool,
      educationStage: PropTypes.shape(PropTypes.shape),
    }),
  };

  static defaultProps = {
    dto: null,
  };

  constructor() {
    super();
    this.state = {
      listOfEducationStage: [],
    };
  }

  componentDidMount() {
    let { dto } = this.props;
    const { initialize, backHandler, t } = this.props;
    this.loadEducationStage();
    if (dto) {
      if (dto.id) {
        this.showLoading();
        const filter = {
          id: dto.id,
          active: true,
          filterByStatus: false,
          updaterId: 0,
          name: '',
        };
        const getItemByIdQuery = schoolGradeListByFilter(filter);
        GraphQL(getItemByIdQuery, {})
          .then((res) => {
            this.hideLoading();
            const schoolGradeList = res.schoolGradeListByFilter;
            if (schoolGradeList.length > 0) {
              dto = { ...schoolGradeList[0] };
              if (dto.educationStage) {
                dto.educationStage.value = dto.educationStage.id;
                dto.educationStage.label = dto.educationStage.name;
              }
              initialize({
                ...dto,
              });
            } else {
              showNotificationAutoDestroy(
                'danger',
                t('notifications.error'),
                t('notifications.record-not-found')
              );
              backHandler();
            }
          })
          .catch(() => {
            showNotificationAutoDestroy(
              'danger',
              t('errors.title'),
              t('errors.error-to-loading')
            );

            this.hideLoading();
          });
      } else {
        initialize({
          ...dto,
        });
      }
    }
  }

  showLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
  }

  hideLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingFalse());
  }

  loadEducationStage() {
    const { t } = this.props;
    this.showLoading();
    const filter = {
      id: 0,
      active: true,
      filterByStatus: true,
      updaterId: 0,
      name: '',
    };
    const dataQuery = educationStageListByFilterQuery(filter);
    GraphQL(dataQuery, {})
      .then((res) => {
        this.hideLoading();
        let educationStageList = res.educationStageListByFilter;
        if (educationStageList) {
          educationStageList = educationStageList.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }));
          this.setState({ listOfEducationStage: educationStageList });
        }
      })
      .catch(() => {
        this.hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-loading')
        );
      });
  }

  render() {
    const { t, backHandler, handleSubmit } = this.props;
    const { listOfEducationStage } = this.state;
    return (
      <SmartCard title={t('panels.serie')}>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.name')}</span>
            <div className="form__form-group-field">
              <Field
                name="name"
                type="text"
                component={renderField}
                maxLength="50"
                placeholder={t('placeholder.school-grade.name')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('school-grade.education-stage')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="educationStage"
                type="text"
                component={renderSelectField}
                options={listOfEducationStage}
                placeholder={t('placeholder.school-grade.education-stage')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.order')}</span>
            <div className="form__form-group-field">
              <Field
                name="order"
                type="number"
                component={renderField}
                maxLength="3"
                placeholder={t('placeholder.school-grade.order')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Label className="generic__label"> {t('general.active')} </Label>
              <Field
                name="active"
                component={renderCheckBoxField}
                className="colored-click"
              />
            </div>
          </div>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="primary" onClick={backHandler}>
              {t('general.back')}
            </Button>
            <Button color="success" type="submit">
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </form>
      </SmartCard>
    );
  }
}

export default reduxForm({
  form: 'SchoolGradeForm',
  validate,
})(withTranslation('common')(SchoolGradeForm));
